module.exports = __webpack_public_path__ + "assets/images/base_roads_phase4.12463844a365b2ccc67b5fe482d3c50e.svg";